/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { Row, Col, Table, Checkbox, Select, Form, notification, Spin, Space, Button, Drawer, InputNumber, Input, /*Popconfirm,*/ Switch, Typography, Tooltip } from 'antd'
import { FilterOutlined, LogoutOutlined, ArrowLeftOutlined, HomeOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { CountUp } from '../../utils/timer'
import '../warehouse/index.css'
import './index.css'
import Http from '../../utils/http'
import { COOKIE, getCookie, logout, pageHandler } from '../../utils/cookie'
import { constants, timezone } from '../../constants/constants'
import { cloneDeep, set } from 'lodash'
import moment from 'moment'
import { format_gate, cacheRetrieve } from '../../utils/common'
import Cookies from 'universal-cookie'
import AppSyncEventManager from '../../utils/AppSyncEventManager'

const { Option } = Select
const { Text } = Typography
const CHARNUM3COMMA = '^[0-9a-zA-Z]{3}(,([0-9a-zA-Z]{3}))*$'
const CHARNUM3COMMAerr = 'field must contain 3 character alpha-numeric value seperated by a comma'

let FSU_LIST = ['RCF', 'FPS', 'MAN']

function formatAWBNo(awb) {
  let result = ''
  if (awb) {
    result = [awb.slice(0, 3), '-', awb.slice(3)].join('')
  }
  return result
}

function getTimeDifferenceInMinutes(difference) {
  if (difference) {
    return moment().diff(difference, 'minutes')
  } else return 0
}

class ServiceRecoveryDashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      station: getCookie(COOKIE.STATION),
      role: getCookie(COOKIE.ROLE),
      logintype: getCookie(COOKIE.LOGINTYPE),
      clock: '',
      data: [],
      loading: false,
      tableBodyFontSize: localStorage.getItem(`Recovery_${new Cookies().get('station')}`),
      defaultFontSize: 'clamp(14px,1.7vw,1.7vw)',
      visible: false,
      hrs: 6
    }
    this._queue = []
    this._isBusy = false
    this.myRef = React.createRef()
    this.tableRef = React.createRef()
    this.eventManager = null
  }
  componentDidMount() {
    this.fetchList()
    // every 5 mins
    setInterval(() => {
      this.fetchList()
    }, 5 * 60 * 1000) // 5 minutes in milliseconds
  }

  fetchList = async () => {
    // Implementation for fetching the list goes here
    let headers = { station: this.state.station }
    this.setState({ loading: true })
    await Http.get('service_awbs_list?hrs=' + this.state.hrs, { headers: headers }).then(resp => {
      if (resp?.status === 200) {
        if (resp?.data?.data?.length > 0) {
          this.setState({ data: resp?.data?.data })
        } else {
          this.setState({ data: [] })
        }
      }
    })
    this.setState({ loading: false })
  }

  handleRedirect = () => {
    if(this.state.role?.toUpperCase() === 'WAREHOUSE TV') {
      logout()
    } else {
      pageHandler('', this.state.role)
    }
  }
  renderFilterBlock = () => {
    return (
      <>
        <b> Past</b>: {this.state.hrs} Hrs.
      </>
    )
  }

  showDrawer = () => {
    this.setState({ visible: true })
  }

  closeDrawer = () => {
    this.setState({ visible: false })
  }

  clearFilters = () => {
    this.setState({ hrs: 6 })
  }


  render() {

    const awb_columns = [
      {
        title: 'Flight #',
        dataIndex: 'flight_no',
        key: 'flight_no',
        align: 'left',
        className: 'pl-1vw w-10vw',
        render: (_, record) => (
          <span>{record?.flights_in?.flight_no ? record?.flights_in?.flight_no +'/'+ moment(record?.flights_in?.flight_date).format('DDMMMYYYY') : 'N/A'}</span>
        )
      },
      {
        title: 'AWB',
        dataIndex: 'awb_no',
        key: 'awb_no',
        className: 'w-22vw',
        render: (_, record) => (
          <span>{record?.awb_no ? record?.awb_no?.replace(/(\d{3})(\d+)/, '$1-$2') : 'N/A'}</span>
        )
      },
      {
        title: 'Org-Dest',
        dataIndex: 'org_dest',
        key: 'org_dest',
        className: 'w-22vw',
        render: (_, record) => (
          <span>{record?.org +'-'+ record?.dest}</span>
        )
      },
      // {
      //   title: 'Booked Flight',
      //   dataIndex: 'booked_flight',
      //   key: 'booked_flight',
      //   className: 'w-22vw',
      //   render: (_, record) => (
      //     <span>{record?.segs_out?.flight_no ? record?.segs_out?.flight_no + moment(record?.segs_out?.flight_date).format('DDMMMYYYY') : 'N/A'}</span>
      //   )
      // },
      {
        title: 'Flight OUT',
        dataIndex: 'flight_out',
        key: 'flight_out',
        className: 'w-22vw',
        render: (_, record) => {
          let msg= ''
          if(!record?.segs_out && !record?.flights_out) {
            msg = 'Flight info missing'
          } else if(record?.segs_out?.status && record?.segs_out?.status !== 'CFM') {
            msg = 'Booking is not confirmed'
          }else if(record?.flights_out && moment.utc().valueOf() > moment.utc(record?.flights_out?.dept_date).valueOf()) {
            msg = 'Flight is departed'
          } else {
            msg = 'Insufficient handling time'
          }
          return(
            <Tooltip title={msg}>
              <span  style={{
                textDecoration: 'underline',
                color: '#d02139' 
              }} >{record?.flights_out?.flight_no ? record?.flights_out?.flight_no +'/'+ moment(record?.flights_out?.flight_date).format('DDMMMYYYY') : 'N/A'}</span>
            </Tooltip>
          )
        }
      }
    ]

    return (
      <div className='warehouse-screen recovery-dashboard'>
        <div
          className='recovery-content'>
          <div className='text-right f-spacebtw'>
            <div className='no-print'>
              {this.state.role?.toUpperCase() === 'WAREHOUSE TV' ?
                <div className='d-flex'>
                  {
                    this.state.logintype && this.state.logintype === 'DashTV' ? null :
                      <div className='mr-1vw'>
                        <Button className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<ArrowLeftOutlined />} size='large' onClick={() => window.location.href = '/landing-page'} />
                        <p className='btn-text'>Back</p>
                      </div>
                  }
                  <div>
                    <Button className='custom-icon-button warehouse-filter rotate-180' type='primary' shape='circle' icon={<LogoutOutlined />} size='large' onClick={this.handleRedirect} />
                    <p className='btn-text'>Signout</p>
                  </div>
                </div>
                :
                <div>
                  <Button className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<HomeOutlined />} size='large' onClick={this.handleRedirect} />
                  <p className='btn-text'>Home</p>
                </div>
              }
            </div>
            <h1 className='dash-title mr-0 dash-loc'>{this.state.station}</h1>
          </div>
          <div className='clock-container'>
            <Text className='clock-text'>
              {this.state.clock}
            </Text>
          </div>
          <h1 className='text-center'><span className='dash-title'>Service Recovery Dashboard</span></h1>
          <Row
            gutter={[
              {
                xs: 0,
                sm: 0,
                md: 0,
                lg: 0,
              },
              {
                xs: 0,
                sm: 0,
                md: 0,
                lg: 0,
              },
            ]}
          >
            <div className='w-100 f-spacebtw mb-1p5'>
              <div className='d-flex'>
                <div className='selected-filter mb-0 '>Selected Filters:
                  {this.renderFilterBlock()}
                </div>
              </div>
              <div span={2} className='row-1 pr-0 ml-auto no-print'>
                <Space direction='horizontal' className='w-action-btn'>
                  <Button className='custom-icon-button warehouse-filter' type='primary' shape='circle' icon={<FilterOutlined />} size='large' onClick={this.showDrawer} />
                </Space>
              </div>
            </div>
            <Drawer
              title=''
              placement='top'
              width={500}
              closable={false}
              open={this.state.visible}
              className='warehouse-drawer'
            >
              <Row>
                <Button className='close-btn ml-auto' onClick={this.closeDrawer} size='large' type='link'>X</Button>
              </Row>
              <Row
                gutter={[
                  {
                    xs: 0,
                    sm: 0,
                    md: 0,
                    lg: 0,
                  },
                  {
                    xs: 0,
                    sm: 0,
                    md: 0,
                    lg: 0,
                  },
                ]}
                className='warehouse-screen'
              >
                <Col xs={12} sm={12} md={12} lg={6} xl={6} className='row-1'>
                  <Form.Item label='Type'>
                    <Select
                      size='small'
                      value={this.state.hrs}
                      placeholder='Select type'
                      dropdownClassName='warehouse-select'
                      onChange={(e) => this.setState({ hrs: e })}>
                      <Option value={6}>6 Hrs.</Option>
                      <Option value={12}>12 Hrs.</Option>
                      <Option value={18}>18 Hrs.</Option>
                      <Option value={24}>24 Hrs.</Option>
                      <Option value={30}>30 Hrs.</Option>
                      <Option value={36}>36 Hrs.</Option>
                      <Option value={42}>42 Hrs.</Option>
                      <Option value={48}>48 Hrs.</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col className='ml-auto'>
                  <Space direction='horizontal'>
                    <Button type='primary' className='custom-button warehouse-button mr-2vw' onClick={this.clearFilters}>Clear filters</Button>
                    <Button className='custom-button warehouse-button' onClick={() => this.fetchList()} type='primary'>Apply filters</Button>
                  </Space>
                </Col>
              </Row>
            </Drawer>
          </Row>
          <Row
            gutter={[
              {
                xs: 0,
                sm: 0,
                md: 0,
                lg: 0,
              },
              {
                xs: 0,
                sm: 0,
                md: 0,
                lg: 0,
              },
            ]}
          >
            <Col xs={24} sm={24} md={24} lg={24} className='' ref={this.tableRef}>
              {
                <Spin spinning={this.state.loading}>
                  {this.state.data?.length === 0 && <Table
                    className='components-table-demo-nested warehouse-table recovery-table nth-td-p-0'
                    columns={awb_columns}
                    dataSource={this.state.data}
                    pagination={false}
                  />}

                  <div>
                    {this.state.data?.length > 0 && <Table
                      className='components-table-demo-nested warehouse-table recovery-table nth-td-p-0'
                      columns={awb_columns}
                      dataSource={this.state.data}
                      pagination={false}
                      rowKey='id'
                      onRow={() => {
                        return { style: { fontSize: `${this.state.tableBodyFontSize === null || this.state.tableBodyFontSize === 'null' ? this.state.defaultFontSize : `${this.state.tableBodyFontSize}vw`}` }, }
                      }}
                      onHeaderRow={() => {
                        return { style: { fontSize: `${this.state.tableBodyFontSize === null || this.state.tableBodyFontSize === 'null' ? this.state.defaultFontSize : `${this.state.tableBodyFontSize}vw`}`, }, }
                      }}
                    />}
                  </div>

                </Spin>
              }
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

export default ServiceRecoveryDashboard
